import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { MenuCellRenderer, NameCellRenderer } from '../cellRenderers';
import type { IRowWithCommonOptions } from '../types';

import type { StateName } from './useEditState';

interface IUseUpdateWorkScopeColumns {
    setValueState: (stateName: StateName, newState: boolean) => void;
    isKebabDisabled?: boolean;
}

export const useUpdateWorkScopeColumns = (props: IUseUpdateWorkScopeColumns) => {
    const { setValueState, isKebabDisabled } = props;

    return useMemo<ColDef<IRowWithCommonOptions>[]>(
        () => [
            {
                resizable: false,
                rowDrag: true,
                width: 10,
            },
            {
                field: 'name',
                valueFormatter: ({ data, node }) => `${(node?.rowIndex || 0) + 1}. ${data?.name}`,
                flex: 1,
                cellRenderer: NameCellRenderer,
                cellRendererParams: {
                    setValueState,
                },
                equals: () => false,
            },
            {
                field: 'menu' as any,
                headerName: '',
                width: 50,
                cellRenderer: MenuCellRenderer,
                cellRendererParams: {
                    setValueState,
                    isKebabDisabled,
                },
                equals: () => false,
            },
        ],
        [isKebabDisabled, setValueState],
    );
};
